import { YourPage } from '../Gamification/YourPage'
import type { Workspace } from '../../types/workspace'
import type { WorkspaceRole } from '../../context/WorkspaceContext'
import { roleCanPerform } from '../../utils/workspacePermissions'
import { useNls } from '../../nls/nlsProvider'
import { roleLabelKey } from '../../utils/roleLabels'

export const MemberPageComposite = ({
  workspace,
  role,
}: {
  workspace: Workspace
  role: WorkspaceRole
}) => {
  const { t } = useNls()
  return (
    <section className="memberPageComposite" aria-label="Member page">
      <YourPage onBack={() => undefined} />
      <aside className="memberWorkspaceSummary" aria-label="Workspace settings summary">
        <span className="memberEyebrow">Workspace</span>
        <h2>{workspace.name}</h2>
        <dl>
          <div>
            <dt>Workspace ID</dt>
            <dd>{workspace.slug}</dd>
          </div>
          <div>
            <dt>Your role</dt>
            <dd>{t(roleLabelKey(role))}</dd>
          </div>
          <div>
            <dt>Plan</dt>
            <dd>{workspace.plan.replaceAll('_', ' ').toLocaleLowerCase()}</dd>
          </div>
          <div>
            <dt>Settings</dt>
            <dd>{roleCanPerform(role, 'ADMIN') ? 'Editable in admin workspace settings' : 'Read-only for this shell'}</dd>
          </div>
        </dl>
      </aside>
    </section>
  )
}
